module.exports = __webpack_public_path__ + "static/charje-142ffc446d510f960c2950d678eb2409.png";